import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

const LOGO = "https://customer-assets.emergentagent.com/job_3db06d80-1889-4f74-a8be-2bd587fc72ce/artifacts/exnvtfmt_ChatGPT%20Image%20Jul%203%2C%202026%20at%2003_34_49%20PM.png";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (!res.ok) setError(res.error);
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <img src={LOGO} alt="Marrsing" className="login-logo" data-testid="login-logo" />
        <div className="login-title">Executive Operating System</div>
        <div className="login-sub">MarrsingClause® · MEOS v2.0</div>

        {error && <div className="login-error" data-testid="login-error">{error}</div>}

        <label className="field-label" htmlFor="email">Email</label>
        <input
          id="email" type="email" className="field-input" data-testid="login-email-input"
          value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@marrsing.com" autoComplete="email" required
        />

        <label className="field-label" htmlFor="password">Password</label>
        <input
          id="password" type="password" className="field-input" data-testid="login-password-input"
          value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••" autoComplete="current-password" required
        />

        <button type="submit" className="login-btn" data-testid="login-submit-button" disabled={loading}>
          {loading ? "Signing in…" : "Enter Command Center"}
        </button>

        <div className="login-hint">Executive access only.<br />Positive Relationship Transformation.</div>
      </form>
    </div>
  );
}
